import 'jquery';
import Fuse from '../util/fuse.min';
export default {
	init() { // produce data-attribute
		var all_obj = [];
		$("tr.rezibox-content").each(function(i) {
			var obj = {};
			$(this).find("tbody").children().each(function() {
				var key = $(this).children().eq(0).html();
				var value = $(this).children().eq(1).html();
				value = value.replace(/<a href=".*">|<\/a+>|&nbsp;/g, "").trim();

				if (key==="Titel") {
					obj.Titel_ganz = value;
					value = value.toLowerCase();
					value = value.replace(/der |die |das /, "");
				}

				// count stars
				if (key==="Bewertung") {
					var stars = $(this).children().eq(1).children("span.glyphicon");
					value = 5 - stars.filter(".glyphicon-star").length + stars.filter(".glyphicon-star-empty").length * 0.5;
				}
				obj[key] = value;
			});
			obj.Chronologisch = i;
			obj["Zufall (entdecke etwas Neues)"] = Math.random();
			obj.selfContent = $(this);
			obj.selfInfo = $(this).prev();
			all_obj.push(obj);

			$(this).prev().data("rezibox", obj);
			$(this).data("rezibox", obj);
		});



		// sorting
		var sortby = "Titel";
		$("#reziindex-search-by > a").click(function() {
			sortby = $(this).html().trim();
            $("#reziindex-search-by-button").html(sortby);
			if(sortby==="Zufall (entdecke etwas Neues)") {
				for(var o in all_obj) {
					all_obj[o]["Zufall (entdecke etwas Neues)"] = Math.random();
				}
			}
			sortBy();
		});

		function sortBy() {
			var index = $("#reziindex-list > tr").sort(function(elemA,elemB) {
				if(!$(elemA).data().rezibox.hasOwnProperty(sortby)){
					console.log("Dieser Schlüssel wurde nicht gefunden für:",$(elemA).data().rezibox.Titel,elemA);
				}
				var aval = $(elemA).data().rezibox[sortby];
				var bval = $(elemB).data().rezibox[sortby];
				return (aval===bval) ? 0 : (aval > bval) ? 1 : -1;
			});
			index.css("display","");
			index.appendTo("#reziindex-list");
		}
		sortBy();


		// searching
		var fuse = new Fuse(all_obj, {
			shouldSort: true,
			threshold: 0.6,
			location: 0,
			distance: 100,
			maxPatternLength: 32,
			minMatchCharLength: 1,
			keys: [
				"Titel_ganz",
				"Autor",
				"Verlag",
				"Genre",
			],	
		});
		$("#reziindex-search-str").keyup(function() {

			var search_text = document.getElementById("reziindex-search-str").value.trim();
			if(search_text === "") {
				sortBy();
				return;
			}

			var results = fuse.search(search_text);
			$("#reziindex-list > tr").hide();
			var elements = [];
			for(var i=0; i<results.length; i++) {
				elements.push(results[i].selfInfo);
				elements.push(results[i].selfContent);
			}
			elements = $(elements).map(function() {return this.toArray();});
			elements.css("display","");
			elements.appendTo("#reziindex-list");

		});
		// TODO: var



		// TODO: Fehler bei faschem key-namen!

	},
};



// WEBPACK FOOTER //
// ./scripts/routes/rezensionsindex.js